import {
    AdminEditViewAccessRights,
    UserId,
    StandardAccessRight,
    UserOverview,
} from "api/generated/model";
import { ACCESS_RIGHTS } from "utils/accessRights/constants";

type UsersByAccessRights = Map<StandardAccessRight, UserOverview[]>;

export function toUsersByAccessRights(
    accessRights: AdminEditViewAccessRights,
    users: UserOverview[]
): UsersByAccessRights {
    const userIdsToUsers = (userIds: UserId[]) => {
        const idSet = new Set(userIds);
        const result = users.filter((u) => idSet.has(u.id));

        // detect missing users
        const foundIds = new Set(result.map((u) => u.id));
        const missing = userIds.filter((id) => !foundIds.has(id));

        if (missing.length > 0) {
            throw new Error(`Users not found for IDs: ${missing.join(", ")}`);
        }

        return result;
    };

    const usersByAccessRights = new Map([
        [ACCESS_RIGHTS.ADMIN, userIdsToUsers(accessRights.admin)],
        [ACCESS_RIGHTS.EDIT, userIdsToUsers(accessRights.edit)],
        [ACCESS_RIGHTS.VIEW, userIdsToUsers(accessRights.view)],
    ]);

    return usersByAccessRights;
}
